var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17651 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.6846 5.49247 12.0845 4.04751 11.0185 2.98152C9.95249 1.91554 8.50753 1.31539 7 1.3125V1.3125ZM8.82656 7.32266L6.63907 9.29141C6.55788 9.36435 6.45289 9.40518 6.34375 9.40625C6.283 9.40657 6.22286 9.39407 6.16726 9.36957C6.11166 9.34507 6.06186 9.30912 6.0211 9.26406C5.9428 9.17848 5.9017 9.0653 5.90682 8.94942C5.91195 8.83353 5.96289 8.72443 6.04844 8.64609L7.875 7L6.04844 5.35391C5.96575 5.27486 5.9173 5.16658 5.91348 5.05225C5.90966 4.93792 5.95078 4.82665 6.02801 4.74226C6.10524 4.65788 6.21245 4.6071 6.32667 4.60081C6.44089 4.59451 6.55303 4.63321 6.63907 4.70859L8.82656 6.67734C8.87132 6.71833 8.90707 6.76818 8.93152 6.82373C8.95597 6.87928 8.9686 6.93931 8.9686 7C8.9686 7.06069 8.95597 7.12072 8.93152 7.17627C8.90707 7.23182 8.87132 7.28167 8.82656 7.32266V7.32266Z",
    fill: "#C6D101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon2.bfecee95f71aa11fe642d16c2ef18ce4.svg";
export { ForwardRef as ReactComponent };